
const state = {
  all: {}
};

const actions = {

};

const mutations = {

};

export const family = {
  namespaced: true,
  state,
  actions,
  mutations
};
